import {shallowEqual, useSelector} from 'react-redux';
import {Typography} from '~library/atoms/Typography';
import {selectRsvpStyle} from '../../reducers/eventDetails';

export const RsvpLabel = (props) => {
  const {label} = props;

  const rsvpCounts = useSelector(({guestList: s}) => s.rsvpCounts);

  const allowKids = useSelector((state) => state.eventDetails?.allowKids);

  let displayLabel = label;
  const customLabel = useSelector(selectRsvpStyle, shallowEqual);
  const hasCustomLabel = label !== 'no_reply' && customLabel[label].toLowerCase() !== displayLabel;
  if (displayLabel === 'no_reply') displayLabel = 'no reply';

  let rsvpCount;
  const adults = rsvpCounts[`adults_${label}`];
  const kids = rsvpCounts[`kids_${label}`];

  if (allowKids && ['yes', 'maybe'].includes(label)) {
    const adultsCopy = `${adults} Adult${adults === 1 ? '' : 's'}`;
    const hasKids = kids !== 0;
    const kidsCopy = ` ${kids} Kid${kids === 1 ? '' : 's'}`;
    rsvpCount = adultsCopy + (hasKids ? kidsCopy : '');
  } else {
    rsvpCount = rsvpCounts[label];
  }

  return (
    <div className={`wic__rsvp-group-label-wrapper ${label}`}>
      <Typography
        data-qa-id={`${label}-section-header`}
        variant="paragraph2"
        classNames="wic__rsvp-group-label"
        color="charcoal"
      >
        {displayLabel}
        {hasCustomLabel && (
          <Typography data-qa-id={`customRsvp_${label}`} variant="paragraph3" color="charcoal">
            {customLabel[label]}
          </Typography>
        )}
      </Typography>
      <Typography
        data-qa-id={`${label}-guest-count`}
        data-qa-value={adults && kids ? adults + kids : undefined}
        variant="paragraph2"
        classNames="wic__rsvp-group-label"
        color="charcoal"
      >
        ({rsvpCount})
      </Typography>
    </div>
  );
};
